import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {  Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ApiConstants } from 'src/app/constants/api-constants';
import { DataBroadcast, EntityListPayloadModel, EntitySummaryModel, EntitySummaryPayloadModel, EntitySummaryResponseModel, TrackerTabStateModel } from 'src/app/model';
import { DataService, GeneralService, ImageUrlCacheService, ServicecallService } from 'src/app/services';
import { FloorPlanService } from 'src/app/shared/floor-plan/service/floor-plan.service';
import { EntitiesServiceService, EntitySiteService } from 'src/app/shared/services';
import { AttributeListingModalComponent } from './attribute-listing-modal/attribute-listing-modal.component';
import { Messages } from 'src/app/constants/messages';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-entities-details',
  templateUrl: './entities-details.component.html',
  styleUrls: ['./entities-details.component.css']
})
export class EntitiesDetailsComponent implements OnChanges, OnDestroy {

  @Input() entitiesStatus: { status: string, color: string };
  @Input() entityDetails: any;
  @Input() periodFilter: any;
  @Output() checkPointExpand = new EventEmitter<any>();
  @Input() fromDate: string;
  @Input() toDate : string;
  tileData: any = [];
  image: any;
  primaryDetails: any[];
  iconsList: any;
  token: any = ApiConstants.blobSasToken;
  trlConfig: any = {};
  popRoute: boolean = false;
  isCategoryShow: boolean = false;
  timeStamp: number = +new Date();
  floorplanRedirect: boolean = false;
  aggrDetails: any;
  listingDetails: any;
  entityData: any
  entityId: string;
  ignitionStatus: number;
  rpm: number;
  public defaultImage: string = null;
  public defaultImageVot: string;
  activeAlertsCount: number;

  private _filterLists: any[] = [];
  private _subscription: Subscription;
  private _getMappingDetailsSubscription: Subscription;
  private _afterClosedSubscription: Subscription;
  private _entitiesListSubscription: Subscription;
  private _getAlertsCountSubscription: Subscription;
  private _startTime: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    0,
    0,
    0,
    999
  );
  private _getEntityDataSubscription: Subscription;
  private _dtcCountSubscription: Subscription;
  dtcCasesCount: number;
  private _entitySummarySubscription: Subscription;
  summary: {timeTakenInMin: number, distanceTravelled: number} ;

  constructor(
    public service: EntitiesServiceService,
    public sharedService: ServicecallService,
    private _dialog: MatDialog,
    private _dataSer: DataService,
    private _router: Router,
    private _floorPlanService: FloorPlanService,
    private _siteService: EntitySiteService,
    private _datePipe: DatePipe,
    private _entityService: EntitiesServiceService,
    private _generalService: GeneralService,
    private _imageUrlCacheService: ImageUrlCacheService

  ) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === DataBroadcast.SITE_CHANGED || res.name === DataBroadcast.API_REFRESH) {
        this.openMappingDetails(false);
      }
    });
  }

  ngOnInit(): void {
    const payload = {
      siteId: sessionStorage.getItem('siteId') ?
        JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
    };
    this._floorPlanService.getEntitydetails(payload).subscribe({
      next: (result) => {
        this.floorplanRedirect = result[result?.findIndex(item => item?.entityId === this.entityDetails?._id)].coordinates?.x ? true : false;
      }
    });
    this.entityId = this._router.url.split('/')?.[3];
  }

  ngOnChanges() {
    this._getTileData();
    if (this.entityDetails?._id) {
      // this.activeAlertsCountData();
      // this.getEntitiesData();
      this._configurations();
      this.openMappingDetails(false);
      this._getEntitiesData();
      this._setDtcCountForEntity();
      this._activeAlertsCountData();
      this.getLiveDistanceOpHrs();
    }
    this.trlConfig = this.sharedService.getConfiguration('tenantGenericConfig')
      ? this.sharedService.getConfiguration('tenantGenericConfig')
      : null;
    const configBasedOnCategory = this.sharedService.getConfigurationBasedOnCategory(this.entityDetails);
    this.defaultImage = configBasedOnCategory ? configBasedOnCategory?.defaultImage : this.trlConfig?.defaultImage;
    this.defaultImageVot = this.trlConfig?.defaultImage ? this.trlConfig?.defaultImage?.[this.entityDetails?.category] : '';
    if (this.trlConfig?.tenant === 'VOT' && this.entityDetails?._id) {
      this._getEntityAggrLatestList(this.entityDetails?._id);
      this._getVehicleList(1)
    }
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._getMappingDetailsSubscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();
    this._entitiesListSubscription?.unsubscribe();
    this._getEntityDataSubscription?.unsubscribe();
    this._dtcCountSubscription?.unsubscribe();
    this._getAlertsCountSubscription?.unsubscribe();
    this._entitySummarySubscription?.unsubscribe();
  }

  private _activeAlertsCountData() {
    let configStartDate = null;
    let configEndDate = null;

    if (this.trlConfig?.defaultTimeRange) {
      const configHour = this.trlConfig?.defaultTimeRange || 0;

    const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    this._filterLists = [{ type: 'Status', value: 'active' }];
    const reqData = {
      filterList: this._filterLists,
      from: this._datePipe.transform(this.fromDate ?? (configStartDate?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService.getSiteId(),
      entityId: this.entityDetails?._id,
    };
    this._getAlertsCountSubscription = this.sharedService
      .getAlertsCount(reqData, false)
      .subscribe((result: any) => {
        if (result['status']) {
          const status = result['response']['data']?.find(
            (item: any) => item?.status
          )?.status;
          if (status) {
            this.activeAlertsCount = status?.length
              ? status?.find((item: any) => item?.status)?.count
              : 0;
          }
        } else {
          this.sharedService.toasterService({
            type: 'error',
            msg: result?.response?.message,
          });
        }
      });
  }

  private _getEntitiesData() {
    let configStartDate = null;
    let configEndDate = null;

    if (this.trlConfig?.defaultTimeRange) {
      const configHour = this.trlConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const reqData = {
      from: this._datePipe.transform(this.fromDate ?? (configStartDate ?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService?.getSiteId(),
      entityId: this.entityId,
      entityCategory: this.entityData?.category,
      attributes: ['canbs4.IgnitionStatus', 'canbs4.EngineSpeed', 'motor_rpm']
    };
    this._getEntityDataSubscription = this.service
      .getEntityData(reqData)
      .subscribe({
        next: (result: any) => {
          if (result['response']['data']?.length) {
            this.entityData = result['response']['data'];
            this.entityData?.[0]?.attributes?.forEach(attribute => {
              if (attribute?.attributeName === 'canbs4.IgnitionStatus') {
                this.ignitionStatus = attribute?.attributeValue;
              }
              if (attribute?.attributeName === 'canbs4.EngineSpeed' || attribute?.attributeName === 'motor_rpm') {
                this.rpm = Number(attribute?.attributeValue);
              }
            });
          } else {
            this.entityData = [];
            this.ignitionStatus = 0;
            this.rpm = null;
          }
        },
        error: (error) => {
          if (error) {
            this.entityData = [];
            this.ignitionStatus = 0;
            this.rpm = null;
          }
        },
      });
  }
  openMappingDetails(popOver: boolean = true) {
    this._siteService.setEntityDetails(this.entityDetails);
    const payloadData = {
      type: 4,
      siteId: this.entityDetails?.site?._id,
      entityId: this.entityDetails?._id,
    };
    this.service.getMappingDetails(payloadData).subscribe((res: any) => {
      let entityData;
      if (this.entityDetails?._id) {
        entityData = res?.find((e) => e?.entityId == this.entityDetails?._id);
      } else {
        entityData = res[0];
      }
      if (res?.length) {
        if (popOver) {
          let dialogRef1 = this._dialog.open(AttributeListingModalComponent, {
            // width: '50%',
            height: '90%',
            data: {
              msg: 'Mapping Detials',
              details: { apiDetails: entityData },
            },
            disableClose: true,
          });
          dialogRef1.afterClosed().subscribe((result) => {
            if (result?.status) {
              dialogRef1.close();
              this._dataSer.broadcast('trendUpdate', result?.value);
            }
          });
        } else {
          this._dataSer.broadcast('trendUpdate', entityData?.attributes);
        }
      } else {
        this.sharedService.toasterService({
          type: 'warning',
          msg: 'Mapping details unavailable',
        });
      }
    });
  }

  navigateTo() {
    this._dataSer.broadcast('digitalTwinToggle');
  }

  /**
   * Determines whether navigate to plan click on
   */
  onNavigateToPlanClick() {
    this._router.navigate(
      ['tracker'], 
      {
        state: {
          entityId: this.entityDetails?._id,
          siteId: this.entityDetails?.site?._id,
          zoneId: this.entityDetails?.zoneDetails?.[0] ? this.entityDetails?.zoneDetails?.[0]?.id : null,
          tab: 'FLOOR_PLAN'
        } as TrackerTabStateModel
      }
    );
  }

  /**
   * Gets operational status name
   * @param state 
   * @returns  
   */
  getOperationalStatusName(state: string) {
    if(state){
      return this.trlConfig?.trackerVehicleStateWidgets?.find((item: any)=> item?.state === state);
    } else {
      return null;
    }
  }

  /**
   * Go to catalogue
   */
  goToCatalogue() {
    this._router?.navigate([`/vehicles/profile/${this.entityId}/catalogue`], { state: { data: {modelName: this.entityDetails?.primaryDetails?.model, category: this.entityDetails?.primaryDetails?.category, modelType: this.entityDetails?.secondaryDetails?.engineModel, platformName: this.entityDetails?.primaryDetails?.make, prescriptiveInsight: this.entityDetails?.enablePrescriptiveInsights } } });
  }
  
  /**
   * Gets vehicle list
   * @param pageNo 
   */
  private _getVehicleList(pageNo: any) {
    let configStartDate = null;
    let configEndDate = null;

    if (this.trlConfig?.defaultTimeRange) {
      const configHour = this.trlConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const payloadContent: Partial<EntityListPayloadModel> = {
      status: null,
      searchKey: null,
      sortBy: null,
      filterBy: null,
      operationalStatusFilter: null,
      alertsFilter: null,
      from: this._datePipe.transform(this.fromDate ?? (configStartDate ?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService.getSiteId(),
      type: 1,
      entityIds: [this.entityDetails?._id],
      domain: this.trlConfig?.tenant
    };
    this._entitiesListSubscription = this.sharedService?.entitiesList(payloadContent, pageNo)?.subscribe((result: any) => {
      if (result['status']) {
        this.listingDetails = result['response']['data']?.map((item: any) => ({ ...item, isAction: false }));
      } else {
        this.listingDetails = null;
        this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
   * Gets entity aggr latest list
   * @param entityId 
   */
  private _getEntityAggrLatestList(entityId: string) {
    let configStartDate = null;
    let configEndDate = null;

    if (this.trlConfig?.defaultTimeRange) {
      const configHour = this.trlConfig?.defaultTimeRange || 0;

    const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
    const payload: { entityIds: string[], from: string, to: string} = {
      entityIds: [this.entityId], 
      from: this._datePipe.transform(this.fromDate ?? (configStartDate ?? startDate), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._entityService.getEntityAggrLatestList(payload)?.subscribe((result: any) => {
      this.aggrDetails = result;
    })
  }

  private _configurations() {
    // this.sharedService.configurationsInfo(['entityIconList'], false).subscribe((result: any) => {
    //   if (result['status']) {
    //     if (result['response'].length) {
    //       this.iconsList = result['response']?.[0]?.values?.entityIconList;
    //       this.iconsList = this.iconsList?.find((att: any) => att?.entityType === this.entityDetails?.type?.toString())?.footerIconList;
    //     }
    //   }
    //   else {
    //     this.iconsList = [];
    //   }
    // }
    // )
    const filteredIconList = this.sharedService.getConfiguration(
      'entityIconList'
    )
      ? this.sharedService.getConfiguration('entityIconList').entityIconList
      : [];
    this.iconsList = filteredIconList.length
      ? filteredIconList?.find(
        (att: any) => att?.entityType === this.entityDetails?.type?.toString()
      )
        ? filteredIconList?.find(
          (att: any) =>
            att?.entityType === this.entityDetails?.type?.toString()
        )?.footerIconList
        : []
      : [];
  }

  private _getTileData() {
    this.image = this.entityDetails?.image ? this.entityDetails?.image : null;
    this.primaryDetails = this.entityDetails?.primaryDetails
      ? Object.keys(this.entityDetails?.primaryDetails)
      : [];
    this.isCategoryShow = this.sharedService.getConfiguration(
      'tenantGenericConfig'
    )
      ? this.sharedService.getConfiguration('tenantGenericConfig')
        ?.entityProfileCategory
      : false;
  }

  // activeAlertsCountData() {
  //   this.filterLists = [{ type: "Status", value: 'active' }];
  //   const reqData = {
  //     filterList: this.filterLists,
  //     from: this.datePipe.transform(this.startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     to: this.datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     siteId: this.sharedService.getSiteId(),
  //     entityId: this.entityDetails?._id
  //   };
  //   this.sharedService.getAlertsCount(reqData, false).subscribe((result: any) => {
  //     if (result['status']) {
  //       if (result['response']['data'][2]) {
  //         this.activeAlertsCount = result['response']['data'][2].status.map(({ count }) => count);
  //       }
  //     }
  //     else {
  //       this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
  //     }
  //   })
  // }

  // getEntitiesData() {
  //   const reqData = {
  //     from: this.datePipe.transform(this.startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     to: this.datePipe.transform(Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     siteId: this.sharedService.getSiteId(),
  //     entityId: this.entityDetails?._id
  //   };
  //   this.service.getEntityData(reqData).subscribe((result: any) => {
  //     if (result['status']) {
  //       if (result['response']['data']) {
  //         this.dynamicEntityData = result['response']['data'][0]?.attributes?.slice(0, 5);
  //       }
  //     }
  //     else {
  //       this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
  //     }
  //   })
  // }

  private _getDefaultImage() {
    switch (this.entityDetails?.type) {
      case 1:
        return '../../assets/images/Default-vehicle-image.svg';
      case 2:
        return '../../assets/images/Default-asset_image.svg';
      case 3:
        return '../../assets/images/defaultuser.svg';
      default:
        return '../../assets/images/Default-asset_image.svg';
    }
  }

  private _setDtcCountForEntity() {
    let configStartDate = null;
    let configEndDate = null;

    if (this.trlConfig?.defaultTimeRange) {
      const configHour = this.trlConfig?.defaultTimeRange || 0;

      const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    let payload = { entityIds: [this.entityId],
      range : {
        from: this._datePipe.transform(this.fromDate ?? (configStartDate ?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
        to: this._datePipe.transform(this.toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ')
      }
     };
    this._dtcCountSubscription = this.sharedService.getActiveDtcCaseCount(payload)?.subscribe(
      {
        next: (result: {count: number, entityId: string}[]) => {
          if (result?.length) {
            this.dtcCasesCount = result?.find((item) => item?.entityId === this.entityId)?.count || 0;
          } else {
            this.dtcCasesCount = 0;
          }
        },
        error: () => {
          this.sharedService.toasterService({ type: 'error', msg: Messages.ERROR });
          this.dtcCasesCount = 0;
        }
      });
}

    getLiveDistanceOpHrs() {
      let configStartDate = null;
      let configEndDate = null;
  
      if (this.trlConfig?.defaultTimeRange) {
        const configHour = this.trlConfig?.defaultTimeRange || 0;
  
        const { startDate, endDate } = this.sharedService.calculateDateRange(configHour);
        configEndDate = endDate;
        configStartDate = startDate;
      }
      const _filterPayload: EntitySummaryPayloadModel = {
        entityId: this.entityId,
      from: this._datePipe.transform(this.fromDate ?? (configStartDate ?? this._startTime), 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this.toDate ?? (configEndDate ?? Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
      };
      this._entitySummarySubscription = this._entityService.getEntitySummary(_filterPayload)
      .subscribe({
        next: (result: EntitySummaryResponseModel) => {
          this.summary = {
            timeTakenInMin: this.sharedService.getConfiguration('tenantGenericConfig')?.timeTakenIn === 'hr' ? result?.timeTakenInMin : (result?.timeTakenInMin / 60), // Converts minute to hour
            distanceTravelled: (result?.distanceTravelled) 
          }
        },
        error: (errorResponse: HttpErrorResponse) => {
          this.sharedService.toasterService({ type: 'Error', msg: errorResponse?.error?.response?.message });
        }
      });
    }

    /**
     * Pops route click
     */
    popRouteClick() {
      this.popRoute = !this.popRoute;
      if(this.popRoute) {
         this.checkPointExpand.emit(this.popRoute)
       }
    }
}
